import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './themes/index.js';

import React from 'react';
import { render } from 'react-dom';

//import registerServiceWorker from './registerServiceWorker';
//import { Provider } from 'react-redux'

import { createStore } from 'redux';
import rootReducer from './reducers';
import Root from './root.js';

//import styles
import 'weui';
import 'react-weui/build/packages/react-weui.css';
import './iconfont.css';
import './index.css';
import './animate.min.css';

let store = createStore(rootReducer);

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <Root store={store} />
    </MuiThemeProvider>
  );
}

render(<App />, document.querySelector('#root'));

//registerServiceWorker();
